document.addEventListener("turbolinks:load", () => {
  document.querySelectorAll(".password-visibility-toggle").forEach((button) => {
    button.addEventListener("click", () => {
      const input = document.getElementById(button.dataset.target)
      const show = input.type === "password"
      input.type = show ? "text" : "password"
      button.querySelector("i").classList.toggle("fa-eye", !show)
      button.querySelector("i").classList.toggle("fa-eye-slash", show)
    })
  })
})